import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row, Card, CardBody, CardHeader, Button } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { Save, ArrowLeft } from "react-feather";

const AddEdit_CommissionMaster = () => {
  const API_URL_SAVE = "CommissionMaster/0/token";
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/CommissionMaster/Id";
  const API_URL_USER_TYPE = `${API_WEB_URLS.MASTER}/0/token/UserTypeMaster/Id/0`;
  const API_URL_CALCULATION_BASE = `${API_WEB_URLS.MASTER}/0/token/CalculationBaseMaster/Id/0`;
  const API_URL_CALCULATION_TYPE = `${API_WEB_URLS.MASTER}/0/token/CalculationTypeMaster/Id/0`;
  const API_URL_SYSTEM_LEDGERS = `${API_WEB_URLS.MASTER}/0/token/SystemLedgers/Id/0`;

  const [state, setState] = useState({
    id: 0,
    formData: {
      CommissionName: "",
      F_UserTypeMaster: "",
      F_CalculationType: "",
      CommissionValue: "",
      F_CalculationBase: "",
      F_LedgerMaster: "",
      EffectiveFrom: "",
      EffectiveTo: "",
      IsActive: true,
    },
  });

  const [userTypeList, setUserTypeList] = useState([]);
  const [calculationBaseList, setCalculationBaseList] = useState([]);
  const [calculationTypeList, setCalculationTypeList] = useState([]);
  const [ledgerList, setLedgerList] = useState([]);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const nameRef = useRef(null);

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;

    if (Id > 0) {
      setState((prevState) => ({ ...prevState, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  useEffect(() => {
    Fn_FillListData(dispatch, setUserTypeList, "gridData", API_URL_USER_TYPE);
    Fn_FillListData(dispatch, setCalculationBaseList, "gridData", API_URL_CALCULATION_BASE);
    Fn_FillListData(dispatch, setCalculationTypeList, "gridData", API_URL_CALCULATION_TYPE);
    Fn_FillListData(dispatch, setLedgerList, "gridData", API_URL_SYSTEM_LEDGERS);
  }, [dispatch]);

  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.focus();
    }
  }, []);

  const validationSchema = Yup.object({
    CommissionName: Yup.string().required("Commission name is required"),
    F_UserTypeMaster: Yup.string().required("User type is required"),
    F_CalculationType: Yup.string().required("Calculation type is required"),
    CommissionValue: Yup.number()
      .required("Commission value is required")
      .min(0, "Value must be 0 or greater"),
    F_CalculationBase: Yup.string().required("Calculation base is required"),
    F_LedgerMaster: Yup.string().required("Ledger is required"),
    EffectiveFrom: Yup.date().required("Effective from is required"),
    EffectiveTo: Yup.date().required("Effective to is required"),
    IsActive: Yup.boolean(),
  });

  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("user"));
    let formData = new FormData();
    formData.append("CommissionName", values.CommissionName || "");
    formData.append("F_UserTypeMaster", values.F_UserTypeMaster || "");
    formData.append("F_CalculationType", values.F_CalculationType || "");
    formData.append("CommissionValue", values.CommissionValue ?? "");
    formData.append("F_CalculationBase", values.F_CalculationBase || "");
    formData.append("F_LedgerMaster", values.F_LedgerMaster || "");
    formData.append("EffectiveFrom", values.EffectiveFrom || "");
    formData.append("EffectiveTo", values.EffectiveTo || "");
    formData.append("IsActive", values.IsActive !== false);
    formData.append("UserId", obj === null || obj === undefined ? 0 : obj.uid);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "rateid",
      navigate,
      "/CommissionMaster"
    );
  };

  return (
    <div style={{ padding: "6px 8px", maxWidth: 900, margin: "0 auto" }}>
      <Card className="border shadow-none" style={{ marginBottom: 0 }}>
        <CardBody className="p-2" style={{ padding: "8px 12px !important" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6, paddingBottom: 4, borderBottom: "1px solid #dee2e6" }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>Commission Master</span>
            <div style={{ display: "flex", gap: 6 }}>
              <Button type="button" size="sm" color="light" className="py-1 px-2" style={{ fontSize: 12 }} onClick={() => navigate("/CommissionMaster")}>
                <ArrowLeft size={12} className="me-1" />Back
              </Button>
              <Button type="submit" form="commission-form" size="sm" color="primary" className="py-1 px-2" style={{ fontSize: 12 }}>
                <Save size={12} className="me-1" />Save
              </Button>
            </div>
          </div>
          <Formik
                  initialValues={{
                    CommissionName: state.formData.CommissionName || "",
                    F_UserTypeMaster: state.formData.F_UserTypeMaster !== undefined && state.formData.F_UserTypeMaster !== null ? String(state.formData.F_UserTypeMaster) : "",
                    F_CalculationType: state.formData.F_CalculationType !== undefined && state.formData.F_CalculationType !== null ? String(state.formData.F_CalculationType) : "",
                    CommissionValue: state.formData.CommissionValue ?? "",
                    F_CalculationBase: state.formData.F_CalculationBase !== undefined && state.formData.F_CalculationBase !== null ? String(state.formData.F_CalculationBase) : "",
                    F_LedgerMaster: state.formData.F_LedgerMaster !== undefined && state.formData.F_LedgerMaster !== null ? String(state.formData.F_LedgerMaster) : "",
                    EffectiveFrom: state.formData.EffectiveFrom ? state.formData.EffectiveFrom.toString().slice(0, 10) : "",
                    EffectiveTo: state.formData.EffectiveTo ? state.formData.EffectiveTo.toString().slice(0, 10) : "",
                    IsActive: state.formData.IsActive !== false,
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize={true}
                >
                  {({ isSubmitting, errors, touched, handleSubmit }) => (
                    <Form id="commission-form" onSubmit={handleSubmit} style={{ marginTop: 4 }}>
                      <Row style={{ gap: "0 8px", rowGap: 2 }}>
                        <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                          <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Name <span className="text-danger">*</span></label>
                          <Field innerRef={nameRef} className={`form-control form-control-sm ${errors.CommissionName && touched.CommissionName ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="text" name="CommissionName" placeholder="Name" />
                          <ErrorMessage name="CommissionName" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                        </Col>
                        <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                          <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>User Type <span className="text-danger">*</span></label>
                          <Field as="select" className={`form-select form-select-sm ${errors.F_UserTypeMaster && touched.F_UserTypeMaster ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="F_UserTypeMaster">
                            <option value="">Select</option>
                            {userTypeList && userTypeList.map((item) => <option key={item.Id} value={item.Id}>{item.Name || item.UserTypeName || item.Id}</option>)}
                          </Field>
                          <ErrorMessage name="F_UserTypeMaster" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                        </Col>
                        <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                          <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Calc Type <span className="text-danger">*</span></label>
                          <Field as="select" className={`form-select form-select-sm ${errors.F_CalculationType && touched.F_CalculationType ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="F_CalculationType">
                            <option value="">Select</option>
                            {calculationTypeList && calculationTypeList.map((item) => <option key={item.Id} value={item.Id}>{item.TypeName || item.Id}</option>)}
                          </Field>
                          <ErrorMessage name="F_CalculationType" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                        </Col>
                        <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                          <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Value <span className="text-danger">*</span></label>
                          <Field className={`form-control form-control-sm ${errors.CommissionValue && touched.CommissionValue ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="number" name="CommissionValue" placeholder="0" step="0.01" min="0" />
                          <ErrorMessage name="CommissionValue" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                        </Col>
                        <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                          <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Calc Base <span className="text-danger">*</span></label>
                          <Field as="select" className={`form-select form-select-sm ${errors.F_CalculationBase && touched.F_CalculationBase ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="F_CalculationBase">
                            <option value="">Select</option>
                            {calculationBaseList && calculationBaseList.map((item) => <option key={item.Id} value={item.Id}>{item.BaseName || item.Id}</option>)}
                          </Field>
                          <ErrorMessage name="F_CalculationBase" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                        </Col>
                        <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                          <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Ledger <span className="text-danger">*</span></label>
                          <Field as="select" className={`form-select form-select-sm ${errors.F_LedgerMaster && touched.F_LedgerMaster ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="F_LedgerMaster">
                            <option value="">Select</option>
                            {ledgerList && ledgerList.map((item) => <option key={item.Id} value={item.Id}>{`${item.LedgerName || item.LedgerCode || item.Id}${item.LedgerName && item.LedgerCode ? ` (${item.LedgerCode})` : ""}`}</option>)}
                          </Field>
                          <ErrorMessage name="F_LedgerMaster" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                        </Col>
                        <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                          <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>From <span className="text-danger">*</span></label>
                          <Field className={`form-control form-control-sm ${errors.EffectiveFrom && touched.EffectiveFrom ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="date" name="EffectiveFrom" />
                          <ErrorMessage name="EffectiveFrom" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                        </Col>
                        <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                          <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>To <span className="text-danger">*</span></label>
                          <Field className={`form-control form-control-sm ${errors.EffectiveTo && touched.EffectiveTo ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="date" name="EffectiveTo" />
                          <ErrorMessage name="EffectiveTo" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                        </Col>
                        <Col xs={6} md={4} style={{ marginBottom: 4, display: "flex", alignItems: "flex-end", paddingBottom: 4 }}>
                          <div className="form-check form-check-sm">
                            <Field className="form-check-input" type="checkbox" name="IsActive" id="IsActive" style={{ marginTop: 6 }} />
                            <label className="form-check-label" htmlFor="IsActive" style={{ fontSize: 11 }}>Active</label>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
        </CardBody>
      </Card>
    </div>
  );
};

export default AddEdit_CommissionMaster;
